<template>
  <div class="service-accordion--wrapper">
    <div>
      <Accordion
        :is-open="isServiceAccordionOpen"
        :on-click-self="true"
        @toggleAccordion="$emit('toggleServiceAccordion')"
        :highlight="baseServicesList.indexOf(serviceName) > -1"
      >
        <template #header>
          <Checkbox
            :is-selected="isSelected"
            :text="headerText"
            @onClick="selectService"
            :is-disabled="isDisabled"
          ></Checkbox>
          <div class="color--selection">
            <div v-if="isSelected" :colorId="isSelected"></div>
            <p v-else class="colors-accordion--placeholder">
              {{ placeholder }}
            </p>
          </div>
          <span class="arrow">
            <Icon
              icon-name="performanceAccordionCaret"
              width="16"
              height="16"
              :direction="isServiceAccordionOpen ? 'down' : 'up'"
              @onClick="$emit('toggleServiceAccordion')"
            >
              <Arrow></Arrow>
            </Icon>
          </span>
        </template>
        <template #body
          ><div class="service-accordion--content">
            <p>
              {{ textContent }}
            </p>
          </div></template
        >
      </Accordion>
    </div>
  </div>
</template>

<script>
import Accordion from "@/components/shared/Accordion";
import Icon from "@/components/shared/Icons/Icon";
import Arrow from "@/components/shared/Icons/arrow.svg";
import Checkbox from "@/components/shared/Checkbox";
import { baseServices } from "@/utils/generic.js";

export default {
  name: "ServiceAccordion",
  components: { Accordion, Icon, Arrow, Checkbox },
  props: {
    isServiceAccordionOpen: {
      type: Boolean,
    },
    isSelected: {
      type: Boolean,
    },
    isDisabled: {
      type: Boolean,
    },
    placeholder: {
      type: String,
    },
    toggleServiceAccordion: {
      type: Function,
    },
    headerText: {
      type: String,
    },
    serviceName: {
      type: String,
    },
    textContent: {
      type: String,
    },
    selectService: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      baseServicesList: []
    };
  },
  mounted() {
    this.baseServicesList = [baseServices.EXTERNAL_WASHING, baseServices.INTERNAL_WASHING];
  },
};
</script>

<style scoped>
.arrow {
  transform: rotate(270deg);
  transition: transform 0.2s linear;
}
.service-accordion--wrapper {
  margin: 16px 0;
}
.service-accordion--content {
  padding: 10px;
  font-size: var(--font-size__small);
  color: var(--gray__darker);
}
</style>
